@if (animatedButton()) {
<div class="fixed right-4 bottom-4 z-30">
  <div class="relative group">
    @if (!disabled()) {
      <div class="absolute bottom-20 pb-2.5 right-2.5 flex flex-col items-end space-y-4 transition-all duration-300" [ngClass]="forceOpen() ? 'opacity-100 visible' : 'opacity-0 invisible group-hover:opacity-100 group-hover:visible'">
        @for (option of options(); track $index) {
          <div class="flex items-center space-x-2.5 transition-all duration-300 ease-out" [ngClass]="forceOpen() ? 'opacity-100 translate-y-0 visible' : 'opacity-0 translate-y-4 invisible group-hover:opacity-100 group-hover:translate-y-0 group-hover:visible'" (click)="emitEvent(option)">
            <div
              class="flex justify-center items-center text-white font-semibold text-xl h-11 rounded-md whitespace-nowrap px-2"
              [ngStyle]="{'background-color': '#AE7DE8'}">
              <label class="cursor-pointer">{{ literalService.get(option['text'], true) }}</label>
            </div>
            <div
              class="flex justify-center items-center h-15 w-15 rounded-full shadow-2xl cursor-pointer"
              [ngStyle]="{'background-color': '#AE7DE8'}">
              <img [src]="option['img']" [alt]="option['alt']" class="h-7 w-7" />
            </div>
          </div>
        }
      </div>
    }
    <div class="flex justify-center items-center h-20 w-20 rounded-full shadow-2xl transition-transform duration-300" [ngClass]="{'rotate-45': generalOption() === 'plus', 'cursor-pointer': generalOption() === 'close', 'primary-purple-light-3-background': disabled(), 'primary-purple-light-background': !disabled()}" (click)="generalOption() === 'close' && close.emit()">
      <img [src]="images.close" alt="plus" class="h-7 w-7" />
    </div>
  </div>
</div>
} @else {
    <div>
        <div class="flex justify-center items-center fixed right-2.5 bottom-4 h-20 w-20 primary-purple-light-background rounded-full shadow-2xl cursor-pointer" (click)="close.emit()">
            <img [src]="images.close" alt="close" class="h-7 w-7" />
        </div>
        <div class="flex justify-center items-center fixed right-5 bottom-28 h-15 w-15 rounded-full shadow-2xl cursor-pointer" [ngStyle]="{'background-color': '#AE7DE8'}" (click)="emitEvent()">
            <div class="flex">
                <div class="flex justify-center items-center text-white font-semibold text-xl absolute right-20 bottom-2 px-2 py-2 rounded-md whitespace-nowrap" [ngStyle]="{'background-color': '#AE7DE8'}">
                    <label class="cursor-pointer">{{ literalService.get('setup.makeChanges', true)}}</label>
                </div>
                <img [src]="images.check" alt="check" class="h-7 w-7" />
            </div>
        </div>
    </div>
}